import { Card, Col, Row } from '@themesberg/react-bootstrap';
import React, { useEffect, useState } from 'react';
import { change, Field, initialize, reduxForm } from 'redux-form';

import renderInput from '../../../../components/formComponents/renderInput';
import SubmitButton from '../../../../components/formComponents/SubmitButton';
// import validate from '../../../../validate';
import { maxLength40, required } from '../../../../helpers/validator';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { clearData } from '../../../../actions/globalActions';
import axios from '../../../../apis/axios';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

const DepartmentForm = (props) => {
	const { initials, onSubmit, invalid } = props;
	const { t } = useTranslation();
	const [departmentNameCheck, setDepartmentNameCheck] = useState(false);

	useEffect(() => {
		props.initialize(initials);

		return () => {
			props.clearData();
		};
	}, []);

	useEffect(() => {
		props.change('isValid', !invalid);
	}, [invalid]);

	const checkDepartmentName = (name) => {
		if (name) {
			axios
				.get(`department/check/${name}`)
				.then((response) => {
					setDepartmentNameCheck(response.data);
				})
				.catch((err) => {});
		} else {
			setDepartmentNameCheck(false);
		}
	};

	return (
		<form onSubmit={props.handleSubmit(onSubmit)}>
			<Row>
				<Col xl={8} lg={8} md={12} sm={12} xs={12}>
					<Card border="light" className="bg-white shadow-sm mb-4  w-100">
						<Card.Body>
							<h5 className="mb-4">{t('department-form')}</h5>
							<Row className="">
								<Col className="mb-3">
									<Field
										validate={[required, maxLength40]}
										onChange={(e) => checkDepartmentName(e.target.value)}
										name="departmentName"
										label={t('department-name')}
										component={renderInput}
									/>
								</Col>
							</Row>
							{departmentNameCheck && <strong className="text-danger">{t('department-already-exists')}</strong>}
							<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
								<a onClick={() => window.history.back()} className="btn btn-secondary">
									{t('back')}{' '}
								</a>
								<SubmitButton disabled={departmentNameCheck} invalid={invalid} onSubmit={onSubmit} text={t('submit')} />
							</div>
						</Card.Body>
					</Card>
				</Col>
				<Col xl={4} lg={4} md={12} sm={12} xs={12}></Col>
			</Row>
		</form>
	);
};

export default compose(
	connect(null, { clearData, initialize, change }),
	reduxForm({
		form: 'department',
	})
)(DepartmentForm);
